window.WCTableData = window.WCTableData || [];
window.WCTableData.push(
{
  "id": "crispy-gnocchi-tomato",
  "priority": 6,
  "name": "CRISPY GNOCCHI TOMATO TABLE",
  "occasions": [
    "friends",
    "dinner",
    "spontaneous"
  ],
  "totalTime": 30,
  "difficulty": 2,
  "vibes": [
    "comfort",
    "mediterranean",
    "sharing"
  ],
  "drinkCats": [
    "beer",
    "wine",
    "alcoholfree",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": false,
  "budgetLow": 10,
  "budgetHigh": 14,
  "reason": "Knusprige Gnocchi plus warme Tomaten funktionieren als unkompliziertes One-Pan-Dinner, das trotzdem nach Hosting aussieht.",
  "food": "Rucola mit Zitrone",
  "main": "Crispy Gnocchi, Burst Tomatoes & Mozzarella",
  "drink": "Cold Lager",
  "naDrink": "Italian Lemon Soda",
  "tableDetail": "Pfanne direkt auf einen Untersetzer in die Tischmitte.",
  "prep": "30 Minuten",
  "hostTip": "Gnocchi nicht zu früh bewegen – erst wenden, wenn eine Seite wirklich Farbe hat.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Cherrytomaten",
      "qty": 500,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Rucola",
      "qty": 120,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Gnocchi",
      "qty": 800,
      "unit": "g"
    },
    {
      "group": "cooling",
      "name": "Mini-Mozzarella",
      "qty": 250,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 45,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 5,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 1,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Lager",
      "qty": 1320,
      "unit": "ml"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Italian Lemon Soda 0.0",
      "qty": 1200,
      "unit": "ml"
    }
  ],
  "equipment": ["sehr große Pfanne", "Salatschüssel", "Pfannenwender", "Servieruntersetzer"],
  "makeAhead": "Rucola waschen und Tomaten trocknen. Die Pfanne erst kurz vor dem Essen starten, damit die Gnocchi knusprig bleiben.",
  "serving": "Mozzarella nur kurz unterheben und die Pfanne direkt auf einem hitzefesten Untersetzer servieren.",
  "steps": [
    "Rucola waschen und vollständig trocknen. Zitrone halbieren und 1 EL Saft für das Dressing auspressen.",
    "Eine sehr große Pfanne 2 Minuten auf mittelhoher bis hoher Stufe erhitzen. 30 ml Olivenöl und die ungekochten Gnocchi hineingeben.",
    "Gnocchi 8–10 Minuten rundherum goldbraun braten. Erst nach etwa 3 Minuten wenden und die Pfanne nicht überfüllen; bei Bedarf in zwei Portionen arbeiten.",
    "Tomaten und 10 ml Olivenöl zugeben, salzen und 5–6 Minuten braten, bis einige Tomaten aufplatzen.",
    "Hitze reduzieren, Mozzarella abtropfen lassen und nur 1 Minute unterheben, damit er warm wird, aber nicht vollständig zerläuft.",
    "Rucola mit restlichem Öl, Zitronensaft, Salz und Pfeffer mischen. Salat separat zur heißen Gnocchi-Pfanne servieren."
  ],
  "drinkSteps": [
    "Lager mindestens 3 Stunden kalt stellen.",
    "Pro Person etwa 330 ml direkt zum heißen Hauptgericht öffnen und sehr kalt servieren."
  ],
  "naDrinkSteps": [
    "Lemon Soda vollständig vorkühlen.",
    "Pro Person etwa 300 ml auf Eis geben und mit einer dünnen Zitronenscheibe servieren."
  ]
},
{
  "id": "mediterranean-mezze-night",
  "priority": 7,
  "name": "MEDITERRANEAN MEZZE NIGHT",
  "occasions": [
    "friends",
    "aperitivo",
    "dinner",
    "spontaneous"
  ],
  "totalTime": 30,
  "difficulty": 2,
  "vibes": [
    "mediterranean",
    "sharing",
    "fresh"
  ],
  "drinkCats": [
    "aperitivo",
    "wine",
    "beer",
    "alcoholfree",
    "open"
  ],
  "diet": "vegan",
  "lactoseLow": true,
  "budgetLow": 11,
  "budgetHigh": 15,
  "reason": "Viele kleine Schalen, wenig Herdzeit und genug Abwechslung für eine Crew – ein planbarer Tisch ohne klassisches Hauptgericht.",
  "food": "Hummus, Zitronen-Oliven & Gurken-Tomaten-Salat",
  "main": "Warme Pita mit gerösteten Kichererbsen",
  "drink": "Orange Tonic Spritz",
  "naDrink": "Orange Tonic Spritz 0.0",
  "tableDetail": "Schalen asymmetrisch verteilen und die Mitte frei für warme Pita lassen.",
  "prep": "30 Minuten",
  "hostTip": "Hummus großflächig auf einen Teller streichen statt in eine kleine Schüssel zu füllen.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Gurke",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Tomaten",
      "qty": 400,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 2,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Petersilie",
      "qty": 20,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Kichererbsen, abgetropft",
      "qty": 800,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Tahini",
      "qty": 100,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Pita",
      "qty": 8,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Oliven",
      "qty": 240,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 60,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Kreuzkümmel",
      "qty": 4,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 5,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Aperitivo bitter",
      "qty": 160,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Tonic Water",
      "qty": 440,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Orange",
      "qty": 2,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Bitter-Aperitif 0.0",
      "qty": 160,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Tonic Water",
      "qty": 440,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Orange",
      "qty": 2,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "equipment": ["Mixer oder Pürierstab", "Pfanne", "Backofen", "große Platte", "mehrere kleine Schalen"],
  "makeAhead": "Hummus und Salat können 2 Stunden vorher vorbereitet werden. Geröstete Kichererbsen und Pita erst kurz vor dem Servieren warm machen.",
  "serving": "Hummus auf einen flachen Teller streichen, warme Kichererbsen darübergeben und Salat, Oliven sowie Pita ringsum verteilen.",
  "steps": [
    "Kichererbsen gründlich abspülen und abtropfen lassen. 400 g für den Hummus und 400 g zum Rösten aufteilen.",
    "Für den Hummus 400 g Kichererbsen, Tahini, Saft von 1 Zitrone, 25 ml Olivenöl, 1/2 TL Kreuzkümmel und 1/2 TL Salz mixen. 80–120 ml eiskaltes Wasser esslöffelweise zugeben, bis er glatt ist.",
    "Restliche Kichererbsen trocken tupfen. Mit 20 ml Olivenöl, restlichem Kreuzkümmel und Salz 8–10 Minuten in einer heißen Pfanne rösten.",
    "Gurke und Tomaten würfeln. Mit gehackter Petersilie, Saft von 1/2 Zitrone, 15 ml Olivenöl und Salz mischen.",
    "Pita bei 180 °C 4–5 Minuten erwärmen und anschließend vierteln. Oliven mit etwas Zitronenschale vermengen.",
    "Hummus auf einen Teller streichen, geröstete Kichererbsen daraufgeben und alle Komponenten gleichzeitig servieren."
  ],
  "drinkSteps": [
    "Vier große Gläser mit Eis füllen und je 40 ml Aperitivo hineingeben.",
    "Je 110 ml Tonic langsam aufgießen, einmal vorsichtig rühren und mit Orange servieren."
  ],
  "naDrinkSteps": [
    "Vier große Gläser mit Eis füllen und je 40 ml 0.0-Bitter-Aperitif hineingeben.",
    "Je 110 ml Tonic aufgießen, vorsichtig rühren und mit Orange servieren."
  ]
},
{
  "id": "date-night-pasta-limone",
  "priority": 8,
  "name": "DATE NIGHT · PASTA AL LIMONE",
  "occasions": [
    "date",
    "dinner"
  ],
  "totalTime": 35,
  "difficulty": 2,
  "vibes": [
    "mediterranean",
    "comfort",
    "fresh"
  ],
  "drinkCats": [
    "wine",
    "cocktail",
    "alcoholfree",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": false,
  "budgetLow": 16,
  "budgetHigh": 22,
  "reason": "Kleiner Salat, sehr gute Pasta und ein sauberer Drink – genug Anlass, ohne dass der Abend zum Kochprojekt wird.",
  "food": "Rucola, Birne & Walnuss",
  "main": "Tagliatelle al Limone mit Pecorino",
  "drink": "White Negroni Spritz",
  "naDrink": "Grapefruit Rosemary Spritz 0.0",
  "tableDetail": "Zwei große Pastateller, eine kleine Salatschüssel, Kerzen – fertig.",
  "prep": "35 Minuten",
  "hostTip": "Pasta erst servieren, wenn beide sitzen. Die Sauce wartet schlechter als ihr.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Rucola",
      "qty": 100,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Birne",
      "qty": 2,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 2,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Walnüsse",
      "qty": 60,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Tagliatelle",
      "qty": 360,
      "unit": "g"
    },
    {
      "group": "cooling",
      "name": "Pecorino",
      "qty": 120,
      "unit": "g"
    },
    {
      "group": "cooling",
      "name": "Butter",
      "qty": 70,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 25,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 5,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 2,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "White Bitter",
      "qty": 120,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Trockener Wermut",
      "qty": 120,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 280,
      "unit": "ml"
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Grapefruitsaft",
      "qty": 240,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 360,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Rosmarin",
      "qty": 4,
      "unit": "Zweige",
      "whole": true
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "equipment": ["großer Topf", "große Pfanne", "feine Reibe", "Salatschüssel", "Zange"],
  "makeAhead": "Walnüsse rösten, Pecorino reiben und den Rucola waschen. Birne und Dressing erst kurz vor dem Essen mischen.",
  "serving": "Pasta in vorgewärmte tiefe Teller geben und den frischen Salat separat reichen.",
  "steps": [
    "Walnüsse in einer trockenen Pfanne 3–4 Minuten rösten, abkühlen lassen und grob hacken.",
    "Rucola mit dünnen Birnenspalten, Walnüssen, Olivenöl, 1 EL Zitronensaft, Salz und Pfeffer mischen.",
    "Pecorino fein reiben und Zitronenschale abreiben. Tagliatelle 2 Minuten kürzer als angegeben kochen; 250 ml Kochwasser sichern.",
    "Butter in einer großen Pfanne bei niedriger Hitze schmelzen. Zitronenabrieb und 120 ml Kochwasser zugeben.",
    "Pasta 1–2 Minuten darin schwenken. Pfanne vom Herd ziehen und Pecorino portionsweise einarbeiten.",
    "Bei Bedarf mehr Kochwasser ergänzen. Mit Zitronensaft, Salz und viel Pfeffer abschmecken und sofort servieren."
  ],
  "drinkSteps": [
    "Zwei große Gläser mit Eis füllen und je 30 ml White Bitter sowie 30 ml trockenen Wermut hineingeben.",
    "Je 70 ml Soda aufgießen, kurz rühren und mit Zitronenzeste servieren."
  ],
  "naDrinkSteps": [
    "Zwei Gläser mit Eis füllen und je 60 ml Grapefruitsaft hineingeben.",
    "Je 90 ml Soda aufgießen. Rosmarin zwischen den Händen anschlagen, ins Glas geben und einmal rühren."
  ]
},
{
  "id": "lemon-white-bean-bruschetta",
  "priority": 9,
  "name": "LEMON WHITE BEAN BRUSCHETTA",
  "occasions": [
    "spontaneous",
    "aperitivo",
    "friends",
    "date",
    "dinner"
  ],
  "totalTime": 12,
  "difficulty": 1,
  "vibes": [
    "fresh",
    "mediterranean",
    "sharing"
  ],
  "drinkCats": [
    "wine",
    "alcoholfree",
    "open"
  ],
  "diet": "vegan",
  "lactoseLow": true,
  "budgetLow": 5,
  "budgetHigh": 8,
  "reason": "Sehr wenig Aufwand, sehr wenig Budget und trotzdem ein richtiger Tisch: cremige Bohnen, Zitrone, Kräuter und warmes Brot.",
  "food": "White Bean Smash mit Zitrone & Kräutern",
  "main": "Knusprige Bruschetta mit Tomaten",
  "drink": "Cold White Wine",
  "naDrink": "Lemon Basil Soda",
  "tableDetail": "Bruschetta auf ein langes Brett legen und den Bean Smash daneben streichen.",
  "prep": "12 Minuten",
  "hostTip": "Bohnen nur grob zerdrücken. Textur macht den Unterschied zwischen Dip und Babybrei.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Cherrytomaten",
      "qty": 320,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Basilikum",
      "qty": 20,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Weiße Bohnen, abgetropft",
      "qty": 480,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Baguette",
      "qty": 320,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 45,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 4,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 1,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Trockener Weißwein",
      "qty": 600,
      "unit": "ml"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 600,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Basilikum",
      "qty": 8,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    }
  ],
  "equipment": ["Backblech oder Grillpfanne", "Schüssel", "Gabel oder Kartoffelstampfer", "Servierbrett"],
  "makeAhead": "Bean Smash und Tomaten bis zu 30 Minuten vorher getrennt vorbereiten. Brot erst direkt vor dem Servieren rösten.",
  "serving": "Die Hälfte des Bean Smash auf Brot geben, den Rest als Dip auf dem Brett lassen.",
  "steps": [
    "Backofen auf 220 °C Ober-/Unterhitze vorheizen. Baguette schräg in 1,5 cm dicke Scheiben schneiden.",
    "Brotscheiben mit etwa 15 ml Olivenöl bestreichen und 6–8 Minuten rösten, nach der Hälfte wenden.",
    "Bohnen abspülen, sehr gut abtropfen lassen und mit 20 ml Olivenöl, 2 EL Zitronensaft, Zitronenabrieb, Salz und Pfeffer grob zerdrücken.",
    "Tomaten klein würfeln, leicht salzen und 5 Minuten stehen lassen. Überschüssigen Saft abgießen, dann Basilikum und restliches Olivenöl untermischen.",
    "Bean Smash auf die warmen Brotscheiben verteilen und jeweils etwas Tomatenmischung daraufgeben.",
    "Restlichen Smash und Tomaten separat anrichten, mit Pfeffer und Zitronenabrieb abschließen und sofort servieren."
  ],
  "drinkSteps": [
    "Weißwein auf 8–10 °C vorkühlen.",
    "Pro Person etwa 150 ml einschenken, wenn die Bruschetta fertig angerichtet ist."
  ],
  "naDrinkSteps": [
    "Vier Gläser mit Eis füllen. Je zwei Zitronenscheiben und zwei Basilikumblätter leicht andrücken.",
    "Je 150 ml kaltes Soda aufgießen und einmal umrühren."
  ]
},
{
  "id": "hummus-crunch-flatbreads",
  "priority": 10,
  "name": "HUMMUS CRUNCH FLATBREADS",
  "occasions": [
    "spontaneous",
    "friends",
    "aperitivo",
    "dinner",
    "morning_after"
  ],
  "totalTime": 10,
  "difficulty": 1,
  "vibes": [
    "sharing",
    "fresh",
    "mediterranean"
  ],
  "drinkCats": [
    "beer",
    "alcoholfree",
    "open"
  ],
  "diet": "vegan",
  "lactoseLow": true,
  "budgetLow": 6,
  "budgetHigh": 9,
  "reason": "Zehn Minuten, kaum Abwasch und jeder baut sich sein eigenes Flatbread – maximal unkompliziert für spontane Crews.",
  "food": "Hummus, Gurke, Tomate & Kräuter",
  "main": "Warme Flatbreads mit Crunch-Topping",
  "drink": "Cold Pils",
  "naDrink": "Lemon Mint Fizz 0.0",
  "tableDetail": "Alles in fünf kleine Schalen. Jeder baut selbst.",
  "prep": "10 Minuten",
  "hostTip": "Flatbreads erst ganz zum Schluss wärmen, damit sie weich auf den Tisch kommen.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Gurke",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Tomaten",
      "qty": 300,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Minze",
      "qty": 15,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Hummus",
      "qty": 400,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Flatbreads",
      "qty": 4,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Geröstete Kichererbsen",
      "qty": 120,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 25,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 4,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Pils",
      "qty": 1320,
      "unit": "ml"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 800,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Minze",
      "qty": 12,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    }
  ],
  "equipment": ["Schneidebrett", "Schüssel", "kleine Schalen", "Backofen oder Pfanne"],
  "makeAhead": "Gemüse und Kräuter bis zu 30 Minuten vorher schneiden, aber erst kurz vor dem Essen salzen. Flatbreads zuletzt erwärmen.",
  "serving": "Alle Komponenten getrennt aufstellen, damit jeder selbst baut und der Crunch knusprig bleibt.",
  "steps": [
    "Gurke längs halbieren und mit den Tomaten in kleine Würfel schneiden. Minze grob hacken.",
    "Gemüse mit Minze, 2 EL Zitronensaft, Olivenöl und Salz vermischen. 5 Minuten ziehen lassen und abschmecken.",
    "Hummus in eine breite Schale streichen und mit einem kleinen Schuss Olivenöl sowie Zitronenabrieb abschließen.",
    "Geröstete Kichererbsen in eine eigene Schale geben, damit sie trocken und knusprig bleiben.",
    "Flatbreads bei 180 °C 3–4 Minuten oder in einer trockenen Pfanne je 30 Sekunden erwärmen.",
    "Flatbreads unter einem sauberen Küchentuch warm halten und alle Komponenten gleichzeitig servieren."
  ],
  "drinkSteps": [
    "Pils mindestens 3 Stunden kalt stellen.",
    "Pro Person etwa 330 ml direkt zum Aufbau der Flatbreads öffnen und sehr kalt servieren."
  ],
  "naDrinkSteps": [
    "Vier Gläser mit Eis füllen. Minze und je zwei Zitronenscheiben kurz im Glas andrücken.",
    "Je 200 ml kaltes Soda aufgießen, einmal rühren und sofort servieren."
  ]
}
);
